<template>
  <div class="formContainer">
    <a-form :form="form" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }" @submit="handleSubmit">
      <a-row>
        <a-col :span="24">
          <a-form-item
            label="名称"
            hasFeedback
          >
            <a-input
              placeholder="请输入名称"
              id="name"
              autocomplete="off"
              :disabled="!isEdit"
              v-decorator="['name', { rules: [{ required: true, message: '请输入名称！' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item
            label="描述"
            hasFeedback
          >
            <a-input
              autocomplete="off"
              placeholder="请输入描述"
              id="comment"
              :disabled="!isEdit"
              v-decorator="['comment', { rules: [{ required: true, message: '请输入描述！' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col :span="24" v-show="type==='add'|| type==='edit'" v-if="$auth('datapermission.modifyTable')">
          <a-form-item :wrapper-col="{ span: 12, offset: 5 }" v-if="isEdit">
            <a-button type="primary" html-type="submit" style="margin-right:10px;">
              保存
            </a-button>
            <a-button style="margin-right:10px;" @click="clearForm">
              取消
            </a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { insertTable } from '@/api/table'

export default {
  name: 'ZmForm',
  mounted () {
  },
  data () {
    return {
      isEdit: true,
      model: {},
      lineList: [],
      timeTable: [],
      itemSpan: 8,
      type: 'add',
      form: this.$form.createForm(this, { name: 'config' }),
      labelCol: {
        xs: { span: 6 },
        sm: { span: 24 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 24 }
      }
    }
  },
  methods: {
    setType (type) {
      this.type = type
    },
    // 清空表单
    clearForm () {
      this.model = {}
      this.type = 'add'
      this.$nextTick(() => {
        this.form.resetFields()
      })
    },
    // 设置初始值
    setValue (item) {
      this.model = item
      this.$nextTick(() => {
        this.form.setFieldsValue(item)
      })
    },
    // 提交表单
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          const params = { ...this.model, ...value }
          console.log('this', this)
          // 占位符类型 默认2
          params.type = 2
          delete params.sentence
          delete params.priority
          delete params.value
          if (this.type === 'add') {
            delete params.id
            insertTable(params).then(res => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.clearForm()
                this.$emit('refreshTree')
              } else {
                this.$message.error(res.info.message)
              }
            })
          } else if (this.type === 'edit') {
            insertTable(params).then(res => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.clearForm()
                this.$emit('refreshTree')
              } else {
                this.$message.error(res.info.message)
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
</style>
